module.exports = __webpack_public_path__ + "img/car_4.3b0057c2.jpeg";